import { Link, useNavigate, useLocation } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

export default function LandingNav() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const isSubPage = pathname !== '/'

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 h-14 flex items-center justify-between px-6 bg-[#030712]/80 backdrop-blur-md border-b border-cyan-500/10">
      <div className="flex items-center gap-3">
        {isSubPage && (
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-1.5 font-mono text-xs text-slate-500 hover:text-cyan-400 transition-colors"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            Back
          </button>
        )}
        <Link to="/" className="flex items-center gap-2.5">
        <svg width="24" height="19" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <clipPath id="mtn-nav">
              <path d="M2 27 C5 27 7 22 9 18 C11 14 13 10 16 7 C19 10 21 14 23 18 C25 22 27 27 30 27 Z"/>
            </clipPath>
            <linearGradient id="g-nav" x1="2" y1="7" x2="30" y2="27" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#06b6d4"/>
              <stop offset="100%" stopColor="#3b82f6"/>
            </linearGradient>
          </defs>
          <g clipPath="url(#mtn-nav)">
            <rect x="0" y="7"    width="32" height="2"   fill="url(#g-nav)"/>
            <rect x="0" y="10.5" width="32" height="2"   fill="url(#g-nav)"/>
            <rect x="0" y="14"   width="32" height="2"   fill="url(#g-nav)"/>
            <rect x="0" y="17.5" width="32" height="2"   fill="url(#g-nav)"/>
            <rect x="0" y="21"   width="32" height="2"   fill="url(#g-nav)"/>
            <rect x="0" y="24.5" width="32" height="3"   fill="url(#g-nav)"/>
          </g>
        </svg>
        <span
          className="select-none tracking-widest uppercase"
          style={{
            fontFamily: "'Barlow', sans-serif",
            fontWeight: 900,
            fontSize: '1rem',
            background: 'linear-gradient(135deg, #06b6d4, #3b82f6)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            filter: 'drop-shadow(0 0 8px rgba(6,182,212,0.5))',
          }}
        >
          GCODR
        </span>
      </Link>
      </div>
      <div className="flex items-center gap-6">
        <Link to="/features" className="font-mono text-xs text-slate-500 hover:text-slate-300 transition-colors">Features</Link>
        <Link to="/pricing" className="font-mono text-xs text-slate-500 hover:text-slate-300 transition-colors">Pricing</Link>
        <Link to="/docs" className="font-mono text-xs text-slate-500 hover:text-slate-300 transition-colors">Docs</Link>
        <button
          onClick={() => navigate('/login')}
          className="px-4 py-1.5 rounded-full font-mono text-xs border border-cyan-500/30 text-cyan-400 hover:bg-cyan-500/10 transition-all duration-150"
        >
          Sign In
        </button>
      </div>
    </nav>
  )
}
